import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useUserAuth } from "../contexts/UserAuthContext";
import { normalizeProfileUrl } from "../utils/profilePaths";

/** One-time redirect for bookmarked /profile URLs only — app code uses /user/:id directly. */
const ProfileToUserRedirect = () => {
  const { user } = useUserAuth();
  const location = useLocation();

  if (!user?.id && !user?._id) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const target = normalizeProfileUrl(
    `${location.pathname}${location.search}`,
    user,
  );

  return <Navigate to={target} replace state={location.state} />;
};

export default ProfileToUserRedirect;
